<template>
  <div class="bg">
    <div class="top">
      <h1>购物车
        <span @click="edit" v-if="editTxt">编辑</span>
        <span @click="edit" v-if="editTxt===false">完成</span>
      </h1>
      <p>共{{count}}件商品</p>
    </div>
    <!--商品部分-->
    <div class="shopList" v-for="(item,parentIndex) in cartlist">
      <div class="shopList-top">
        <div class="lf">
          {{checkedCode[parentIndex]}}
          <div class="input-box">
            <input type="checkbox"v-model='isAllChecked[parentIndex]' @change="chooseAll(parentIndex)">
            <label>
              <!--<img src="/static/images/check.png" v-if="isAllChecked[parentIndex]===false" alt="">-->
              <!--<img src="/static/images/checked.png" v-if="isAllChecked[parentIndex]===true" alt="">-->
              <img src="/static/images/check.png" v-if="item.isselected===0" alt="">
              <img src="/static/images/checked.png" v-if="item.isselected===1" alt="">
            </label>
          </div>
          <span>{{item.shopname}}</span>
        </div>
        <div class="rt" v-show="item.couponlist.length>0" @click="getShopCouponList(item.shopid)">领券</div>
      </div>
      <ul>
        <li v-for="(skuscd,index) in item.skuscd">
          {{parentIndex}}--{{index}}
          <div class="input-box">
            <input type="checkbox" :value="skuscd.shopcartproid"  v-model="checkedCode[parentIndex]" @change="singleChecked(skuscd,parentIndex)">
            <label >
              <img src="/static/images/check.png" v-if="skuscd.isselected==0" alt="">
              <img src="/static/images/checked.png" v-if="skuscd.isselected==1" alt="">
            </label>
          </div>
          <div class="box">
            <img :src="url+skuscd.img" alt="">
            <div class="txt">
              <p class="title">{{skuscd.name}}</p>
              <div class="lable">{{skuscd.specsinfo}}</div>
              <div class="price">
                <span class="price-title">￥{{skuscd.price}}</span>
                <div class="add-box">
                  <span @click="dec(skuscd)">-</span>
                  <input type="text" :value="skuscd.count">
                  <span @click="add(skuscd)">+</span>
                </div>
              </div>
              <p class="desc">{{skuscd.prolabels}}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!--结算-->
    <div class="fixed">
      <div class="lf">
        <div class="input-box">
          <input type="checkbox" id="jeiall" @change="allChange">
          <label for="jeiall">
            <img src="/static/images/check.png" v-if="isselect===0">
            <img src="/static/images/checked.png" v-if="isselect===1">
          </label>
        </div>
        <span>全选</span>
        <p v-show="editTxt">
          <span>合计：</span>
          <span>（不含运费）</span>
        </p>
        <h2 class="money" v-show="editTxt">¥{{allmoney}}</h2>
      </div>
      <a href="javaScript:void(0)" class="jie" v-show="editTxt">去结算</a>
      <a href="javaScript:void(0)" class="del" v-show="editTxt==false" @click="del">删除</a>
    </div>
    <!--领券-->
    <div class="mask" v-show="showCoupon">
      <div class="coupon">
        <div class="mask-top">
          <p>优惠券</p>
          <span @click="close(0)">
            <img src="/static/images/del.png" alt="">
          </span>
        </div>
        <ul class="couponList">
          <li v-for="(item,index) in couponList" @click="takecoupon(item.id,index)">
            <img src="/static/images/coupon.png" v-if="item.isReceive===0" alt="">
            <img src="/static/images/no-coupon.png" v-if="item.isReceive===1" alt="">
            <div class="lf">
              ￥<span>{{item.facevalue}}</span>
            </div>
            <div class="rt">
              <p>{{item.couponname}}</p>
              <i class="time">{{item.providetime.split(" ")[0]}} 至{{item.outtime.split(" ")[0]}}</i>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!--修改规格-->
    <div class="mask" v-show="showGui">
     <div class="gui-box">
       <div class="gui-shop">
         <div class="img-box">
           <img src="/static/images/shop-img.png" alt="">
         </div>
         <div class="txt-box">
           <span> <img src="/static/images/del.png" alt=""></span>
           <h1>¥159.00</h1>
           <p>库存7000件</p>
           <h2>已选    “红色”  “3寸”</h2>
         </div>
       </div>
       <div class="guilist">
         <div class="item">
           <p>年龄</p>
           <div class="lable">
             <span>离乳期</span>
             <span>幼猫</span>
           </div>
         </div>
         <div class="item">
           <p>性别</p>
           <div class="lable">
             <span>公</span>
             <span>母</span>
           </div>
         </div>
       </div>
       <a href="javaScript:void(0)" class="save">确定</a>
     </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shop',
  data () {
    return {
      token:'eb3d1d7906eeb199a14a2662d007cc26',
      isselect:'',//是否全选 0-否 1-是
      count:'',// 购物车商品总数量
      allmoney:'',//allmoney
      amountpayable:'',//应付金额
      delmoney:'',//优惠金额,
      cartlist:[],// 购物车列表
      url:'http://mm.yl-mall.cn',
      checkedCode:[],// 选择的商品id
      isAllChecked: [],// 正在进行中的数据是否被选中,
      editTxt:true,// 判断编辑、删除
      couponList:[],// 优惠券
      showCoupon:false,
      showGui:false,
      shopid:'',// 店铺id
    }
  },
  mounted(){
    this.getcartact();
  },
  methods:{
    // 获取购物车信息
    getcartact:function () {
      var _this=this;
      _this.call_net("POST","/api/app/cart/getcartlist",{token:_this.token},function (data) {
        if(data.code===200){
          _this.cartlist=data.data.shops || [];
          _this.allmoney=data.data.allmoney;
          _this.count=data.data.count;
          _this.isselect=data.data.isselect;
          _this.cartlist.forEach(function (el,index) {
            _this.checkedCode.push([])
            if(el.isselected==0){
              _this.isAllChecked.push(false);
            }else{
              _this.isAllChecked.push(false);
              _this.isAllChecked[index]=true;
            };
            // el.skuscd.forEach(function (childEl,childeIndex) {
            //   if(childEl.isselected===1){
            //     _this.checkedCode[index].push(childEl.shopcartproid)
            //   }
            // })
          });
        }
      })
    },
    // 单选
    singleChecked:function (skuscd,parentIndex) {
      console.log(skuscd);
      console.log(this.checkedCode[parentIndex]);
      //判断每一个CheckBox是否选中，全选中让全选按钮选中
     // debugger;
      if(this.cartlist[parentIndex].skuscd.length == this.checkedCode[parentIndex].length){
        this.isAllChecked[parentIndex] = true;
        console.log();
        var ids=this.checkedCode[parentIndex].join(",");
        console.log('ids',ids);
        var sels='';
        var list=this.checkedCode[parentIndex].length;
        for(var i=0;i<list;i++){
          sels+='1,';
        }
        console.log('sels',sels);
        this.selcartlist(ids,sels);
      }else{  // 只要有一个checkbox不选中，让全选按钮不选中
        this.isAllChecked[parentIndex] = false;
      }

      var sel='';
      if(skuscd.isselected===1){
        sel=0
      }else {
        sel=1
      }
      this.selcart(skuscd.shopcartproid,sel);
    },
    // 全选
    chooseAll:function(parentIndex){
      //debugger;
      var _this=this;
      var sels='';
      if(_this.cartlist[parentIndex].isselected===1){
        _this.cartlist[parentIndex].skuscd.forEach(function (el,index) {
          sels+='0,'
        })
      }else {
        _this.cartlist[parentIndex].skuscd.forEach(function (el,index) {
          sels+='1,'
        })
      }
      _this.checkedCode[parentIndex]=[];
      _this.cartlist[parentIndex].skuscd.forEach(function (el,index) {
        _this.checkedCode[parentIndex].push(el.shopcartproid)
      });
      var ids=_this.checkedCode[parentIndex].join(",");
      console.log("ids",ids);
      console.log("sels",sels);
      _this.selcartlist(ids,sels);
    },
    // 底部按钮的全选
    allChange:function(){
      var _this=this;
      var ids=[];
      var sels='';
      _this.cartlist.forEach(function (el,index) {
        el.skuscd.forEach(function (child,index1) {
          ids.push(child.shopcartproid);
          if(_this.isselect===1){
            sels+='0,'
          }else{
            sels+='1,'
          }
        })
      });
      ids=ids.join(",");
      console.log(ids,sels);
      _this.selcartlist(ids,sels);
    },
    //购物车单个选中或取消选中商品
    selcart:function (id,sel) {
      var _this=this;
      var obj={};
      obj.id=id;
      obj.sel=sel;
      obj.token=_this.token;
      _this.call_net("POST","/api/app/cart/selcart",obj,function (data) {
        if(data.code===200){
          _this.getcartact();
        }
      })
    },
    //批量购物车单个选中或取消选中商品
    selcartlist:function (ids,sels) {
      var _this=this;
      var obj={};
      obj.ids=ids;
      obj.sels=sels;
      obj.token=_this.token;
      _this.call_net("POST","/api/app/cart/selcartlist",obj,function (data) {
        if(data.code===200){
          _this.getcartact();
        }
      })
    },
    // 加数量
    add:function (skuscd) {
      var _this=this;
      var count=skuscd.count;
      count++;
      var obj={};
      obj.count=count;
      obj.id=skuscd.shopcartproid;
      obj.token=_this.token;
      console.log(obj);
      _this.call_net("POST","/api/app/cart/changecount",obj,function (data) {
        if(data.code===200){
          _this.getcartact();
        }
      })
    },
    // 减数量
    dec:function (skuscd) {
      var _this=this;
      var count=skuscd.count;
      count--;
      var obj={};
      obj.count=count;
      obj.id=skuscd.shopcartproid;
      obj.token=_this.token;
      console.log(obj);
      _this.call_net("POST","/api/app/cart/changecount",obj,function (data) {
        if(data.code===200){
          _this.getcartact();
        }
      })
    },
    // 编辑或者删除
    edit:function () {
      this.editTxt=!this.editTxt;
    },
    // 批量删除
    del:function () {
      var ids=[];
      var _this=this;
      _this.cartlist.forEach(function (el,index) {
        el.skuscd.forEach(function (child,index1) {
          if(child.isselected===1){
            ids.push(child.shopcartproid);
          }
        })
      });
      ids=ids.join(",");
      console.log(ids);
     // return false;
      _this.call_net("POST","/api/app/cart/deletecartids",{ids:ids,token:_this.token},function (data) {
        if(data.code===200){
          _this.getcartact();
        }
      });

    },
    // 获取店铺优惠券
    getShopCouponList:function (shopid) {
      var _this=this;
      _this.shopid=shopid;
      _this.showCoupon=true;
      //return false;
      _this.call_net("POST","/api/app/coupon/getShopCouponList",{shopid:shopid,token:_this.token},function (data) {
        if(data.code===200){
          _this.couponList=data.data ||[];
        }
      })
    },
    // 关闭弹窗
    close:function (type) {
      if(type===0){
        this.showCoupon=false;
      }
    },
    // 领取优惠券
    takecoupon:function (couponid,index) {
      var _this=this;
      _this.showCoupon=true;
      //return false;
      _this.call_net("POST","/api/app/coupon/takecoupon",{couponid:couponid,token:_this.token},function (data) {
        if(data.code===200){
          _this.couponList[index].isReceive=1;
         // _this.getShopCouponList(_this.shopid);
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bg{
    background-color: rgb(245, 245, 245);
    position: relative;
    height: 100%;
    width: 100%;
  }
  .top{
    background-color: #FF6D32;
    height:3rem;
    padding: 0.3rem;
  }
  .top h1{
    font-size: 0.42rem;
    color: #FFFFFF;
    font-weight: normal;
  }
  .top h1 span{
    font-size: 0.3rem;
    float: right;
  }
  .top p{
    color: #fff;
    font-size: 0.26rem;
    margin-top: 0.1rem;
  }
  .shopList{
    position: relative;
    top:-1rem;
    width: 6.9rem;
    margin: 0 auto;
    padding: 0.3rem;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 0.3rem;
    margin-bottom: 0.3rem;
  }
  .shopList .shopList-top .lf{
    float: left;
  }
  .input-box{
    display: inline-block;
    width: 0.4rem;
    height: 0.4rem;
    position: relative;
    vertical-align: middle;
  }
  .shopList .shopList-top .lf span{
    display: inline-block;
    vertical-align: middle;
    color: #000;
    font-size: 0.28rem;
    margin-left: 0.2rem;
  }
  .input-box input{
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 10;
  }
   .input-box label{
    display: inline-block;
    width: 0.4rem;
    height: 0.4rem;
    position: absolute;
    top:0;
    left: 0;
  }
   .input-box label img{
    display: block;
    width: 100%;
    height: 100%;
  }
  .shopList .shopList-top .rt{
    float: right;
    width: 0.9rem;
    height: 0.38rem;
    text-align: center;
    line-height: 0.38rem;
    background: #FFDCCE;
    font-size: 0.22rem;
    color: #FF6D32;
    border-radius: 0.2rem;
  }
  .shopList ul{
    margin-top: 0.2rem;
  }
  .shopList ul li{
    position: relative;
    box-sizing: border-box;
    padding-left: 0.7rem;
    padding-top:0.3rem;
    padding-bottom: 0.3rem;
    border-bottom: 1px solid #EBEBEB;
  }
  .shopList ul li:last-child{
    border-bottom: none;
  }
  .shopList ul li .input-box{
    position: absolute;
    left: 0;
    top:0.6rem;
  }
  .shopList ul li .box{
    padding-left: 2.1rem;
    box-sizing: border-box;
    position: relative;
  }
  .shopList ul li .box img{
    position: absolute;
    left: 0;
    top:0;
    width: 1.8rem;
    height: 1.8rem;
  }
  .shopList ul li .box .txt .title{
    font-size: 0.26rem;
    color: #333333;
  }
  .shopList ul li .box .txt .lable{
    padding: 0 0.2rem;
    background: #F9F9F9;
    line-height: 0.44rem;
    border-radius: 0.2rem;
    font-size: 0.24rem;
    color: #333333;
    width: fit-content;
    margin-top: 0.16rem;
  }
  .price{
    margin-top:0.25rem;
    margin-bottom: 0.18rem;
  }
  .price .price-title{
    float: left;
    font-size: 0.28rem;
    color: #FF6D32;
    line-height: 22px;
  }
  .price .add-box{
    float: right;
  }
  .price .add-box span{
    font-size: 0.4rem;
    display: inline-block;
    height: 22px;
    line-height: 22px;
    vertical-align: middle;
  }
  .price .add-box input{
    display: inline-block;
    width: 0.76rem;
    height: 0.44rem;
    background-color: #F6F6F6;
    border:none;
    vertical-align: middle;
    margin: 0 0.1rem;
    text-align: center;
  }
  .shopList ul li .box .txt .desc{
    font-size: 0.24rem;
    color: #999999;
  }
  .fixed{
    position: fixed;
    width: 100%;
    background-color: #fff;
    bottom: 0;
    padding-left: 0.6rem;
    box-sizing: border-box;
    height: 1rem;
    overflow: hidden;
  }
  .fixed .lf{
    float: left;
    width: 4.6rem;
    padding-top:0.2rem;
  }
  .fixed>.lf>span{
    display: inline-block;
    vertical-align: middle;
    font-size: 0.3rem;
    color: #333333;
  }
  .fixed>.lf>p{
    display: inline-block;
    vertical-align: middle;
    margin-left: 0.1rem;
  }
  .fixed>.lf>p>span{
    display: block;
    font-size: 0.22rem;
    color: #666666;
  }
  .fixed .money{
    display: inline-block;
    vertical-align: middle;
    font-size: 0.34rem;
    color: #000000;
  }
  .fixed a.jie{
    background-image: linear-gradient(225deg, #FFC532 0%, #FF6632 100%);
    width: 2rem;
    float: right;
    height: 1rem;
    font-size: 0.3rem;
    color: #FFFFFF;
    text-align: center;
    line-height: 1rem;
  }
  .fixed a.del{
    float: right;
    height: 0.6rem;
    width: 1.4rem;
    line-height: 0.6rem;
    border-radius: 0.3rem;
    border: 1px solid #FF6D32;
    font-size: 0.28rem;
    color: #FF6D32;
    text-align: center;
    margin-right: 0.2rem;
    margin-top:0.2rem;
  }
  .mask{
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.50);
    top:0;
    left: 0;
    z-index: 10;
  }
  .coupon{
    position: absolute;
    bottom: 0;
    height: 9.18rem;
    overflow-y: scroll;
    background: #F7F7F7;
    padding: 0.3rem;
    box-sizing: border-box;
  }
  .mask-top{
    margin-bottom: 0.3rem;
  }
  .mask-top p{
    display: inline-block;
    font-size:0.26rem;
    color: #000000;
    font-weight: bold;
  }
  .mask-top span{
    float: right;
    width: 0.32rem;
    height: 0.32rem;
  }
  .mask-top span img{
    display: block;
    width: 100%;
    height: 100%;
  }
  .couponList li{
    position: relative;
    margin-bottom: 0.2rem;
  }
  .couponList li img{
    display: block;
    width: 100%;
    height: 1.9rem;
  }
  .couponList li .lf{
    position: absolute;
    left: 0.74rem;
    top:0.5rem;
    font-size: 0.28rem;
    color: #FF6D32;
  }
  .couponList li .lf span{
    font-size: 0.6rem;
  }
  .couponList li .rt{
    position: absolute;
    left: 2.5rem;
    top:0.5rem;
    z-index: 11;
  }
  .couponList li .rt p{
    font-size: 0.28rem;
    color: #333333;
  }
  .couponList li .rt i{
    display: block;
    font-size: 0.24rem;
    color: #999999;
    margin-top: 0.2rem;
  }
  .gui-box{
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #fff;
    height: 9.18rem;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
    padding: 0.3rem;
    box-sizing: border-box;
  }
  .gui-box .gui-shop{
    position: relative;
    padding-left: 2.2rem;
    height: 2rem;
  }
  .gui-box .gui-shop .img-box{
    position: absolute;
    left: 0;
    width: 2rem;
    height: 2rem;
    border: 1px solid #EEEEEE;
  }
  .gui-box .gui-shop .img-box img{
    display: block;
    width: 100%;
    height: 100%;
  }
  .gui-box .gui-shop .txt-box{
   padding-top: 0.8rem;
  }
  .gui-box .gui-shop .txt-box span{
    position: absolute;
    right: 0;
    top:0;
    width: 0.26rem;
    height: 0.26rem;
  }
  .gui-box .gui-shop .txt-box span img{
    display: block;
    width: 100%;
    height: 100%;
  }
  .gui-box .gui-shop .txt-box h1{
    font-size: 0.38rem;
    color: #FF6D32;
  }
  .gui-box .gui-shop .txt-box p{
    font-size: 0.22rem;
    color: #999999;
  }
  .gui-box .gui-shop .txt-box h2{
    font-size: 0.22rem;
    color: #333;
    font-weight: normal;
  }
  .guilist{
    margin-top: 0.4rem;
  }
  .guilist .item{
    margin-bottom: 0.6rem;
  }
  .guilist .item p{
    font-size: 0.26rem;
    color: #000000;
    margin-bottom: 0.3rem;
  }
  .guilist .item .lable span{
    display: inline-block;
    width: 1.42rem;
    height: 0.56rem;
    text-align: center;
    line-height: 0.56rem ;
    font-size: 0.26rem;
    color: #000000;
    background: #F7F7F7;
    border-radius: 0.28rem;
    margin-right: 0.2rem;
  }
  .guilist .item .lable span.active{
    background-image: linear-gradient(225deg, #FFC532 0%, #FF6632 100%);
    color: #fff;
  }
  .gui-box .save{
    background-image: linear-gradient(225deg, #FFC532 0%, #FF6632 100%);
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    left: 0;
    font-size: 0.32rem;
    color: #FFFFFF;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/shop.vue